import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsService from "../../../api/reservePlanNew.service";

import telematicsService from "../../../api/telematics.service";
import moment from "moment";
import rules from "../../../utils/rules";
import app from "@/utils/app.json";
import schedulerDialog from "@/components/SchedulerDialog";

export default {
  name: "rent-to-date-and-projected-report",
  components: { pageheader, schedulerDialog },
  data() {
    return {
      input: {},
      loadergetcalls: false,
      reportsList: [],
      selected: [
        "Dates",
        "Equipment",
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Search Field",
      ],
      selectedMachine: [],
      filterTypes: [
        { id: "1", name: "Dates" },
        { id: "2", name: "Equipment" },
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "7", name: "Search Field" },
      ],
      isReportLoading: false,
      loadingMachines: false,
      machineSearchFilter: null,
      machines: [],
      zoneSearchFilter: "",
      groupSearchFilter: "",
      groups: [],
      selectedGroup: [],
      jobSiteSearchFilter: "",
      locations: [],
      loadinglocations: false,
      selectedJobSite: [],
      selectedJobSiteNames: [],
      selectedZone: [],
      zonesList: [],
      modelSearchFilter: "",
      models: [],
      selectedModel: [],
      searchMenu: false,
      searchEquipName: "",
      searchPO: "",
      searchJob: "",
      searchContractId: "",
      nodataMachine: false,
      showmachinmsg: true,
      fromDate: "",
      toDate: new Date().toISOString().slice(0, 10),
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      showTable: false,
      show1: false,
      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        {
          text: "Equipment #",
          value: "itemKey",
          styleClass: "sms-equipment-number-col",
        },

        {
          text: "Equipment",
          value: "itemName",
          styleClass: "sms-equipment-name-col",
        },
        { text: "Customer Name", value: "customerName" },
        { text: "Contract #", value: "cntr", styleClass: "sms-contract-col" },
        {
          text: "Contract Status",
          value: "status",
          styleClass: "sms-contract-status-col",
        },
        { text: "Qty", value: "qty", styleClass: "sms-qty-col" },
        {
          text: "Item Status",
          value: "itemStatus",
          styleClass: "sms-status-col",
        },
        { text: "HP", value: "horsePower", styleClass: "sms-hp-col" },
        { text: "Date Out", value: "dateOut", styleClass: "sms-date-col" },
        { text: "Date In", value: "dateDue", styleClass: "sms-date-col" },
        { text: "Day Rate", value: "dailyAmount", styleClass: "sms-money-col" },
        {
          text: "Week Rate",
          value: "weeklyAmount",
          styleClass: "sms-money-col",
        },
        {
          text: "Month Rate",
          value: "monthlyAmount",
          styleClass: "sms-money-col",
        },
        {
          text: "Billed Spend",
          value: "billedCost",
          styleClass: "sms-money-col",
        },
        {
          text: "Projected Spend",
          value: "projectedCost",
          styleClass: "sms-money-col",
        },

        {
          text: "Days On Rent",
          value: "daysOnRent",
          styleClass: "sms-qty-col",
        },
        {
          text: "Date Billed",
          value: "dateBilled",
          styleClass: "sms-date-col",
        },
        { text: "Jobsite", value: "jobsite", styleClass: "sms-jobsite-col" },
        { text: "Job #", value: "jobno", styleClass: "sms-jobno-col" },
        { text: "PO #", value: "pono", styleClass: "sms-pono-col" },
        {
          text: "Ordered By",
          value: "orderedBy",
          styleClass: "sms-orderdby-col",
        },
        {
          text: "Picked Up By",
          value: "contractInfo",
          styleClass: "sms-contractInfo-col",
        },
        {
          text: "Contract Info",
          value: "contractInfo",
          styleClass: "sms-contract-info-col",
        },
        {
          text: "Billed To",
          value: "billedTo",
          styleClass: "sms-contract-info-col",
        },
        {
          text: "Transaction Type",
          value: "transactionType",
          styleClass: "sms-contract-info-col",
        },
        {
          text: "Adjusted Spend",
          value: "adjustedProjectCost",
          styleClass: "sms-money-col",
        },
        {
          text: "Adjusted Date In",
          value: "adjustedDate",
          width: "200px",
        },
      ],
      smsCustomersList: [],
      selectedSMSCustomer: "",
      isCustLoad: false,
      csvName: "Rent To Date.xlsx",
      pdfName: "Rent To Date.pdf",
      isDownloadCSV: false,
      errorMSG: "",
      dateCheck: false,
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",
      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },
        { text: "Name", value: "name", width: "10px" },
        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },
        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",

      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      machineSearchFilterSchedule: null,
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      selectedOwnershipTypeSchedule: ["1", "2"],
      selectedOwnershipFinalSchedule: "",
      searchFieldSchedule: "",
      searchSchedule: "",
      ScheduleReportName: "RENTTODATEPROJECTED",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,
      dailyUtilizationTargetSchedule: 0,
      selectedTimeSchedule: "Hours",
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedMachineSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "",
      selectedcust: "",
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      custnum: "",
      custid: "",
      timeframesList: app.timeframelist,
      scheduledtimeframe: "",
      rules: rules,
      // end scheduled reports data fields
      selectedMachineCount: "",
      loading: false,
      searchField: "",
      searchField1: "",
      menufilter: false,
      exportOptions: ["Excel", "PDF"],
      closeOnContentClick: false,
      isDownloading: false,
    };
  },
  watch: {
    machineSearchFilter(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
    machineSearchFilterSchedule(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  async mounted() {
    this.input = utils.getInputContent("rentToDateReport", this.roles);

    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = "Please select customer to run the report";
      this.showTable = false;
    } else {
      this.errorMSG = "";
      this.showTable = true;
    }
    this.loadergetcalls = false;
    await this.getGroups();
    await this.getLocations();
    await this.getModels();
    await this.getZones();
    this.loadergetcalls = true;
  },
  methods: {
    datesCompare() {
      if (this.fromDate && this.toDate) {
        let dateCheck =
          moment(this.toDate).format("YYYY-MM-DD") >=
          moment(this.fromDate).format("YYYY-MM-DD");
        this.dateCheck = dateCheck;
        if (!this.dateCheck) {
          this.dateErrorMsg = "To Date should be greater than From Date";
        }
      }
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    mindate() {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1))
        .toISOString()
        .slice(0, 10);
    },
    maxdate() {
      return new Date().toISOString().slice(0, 10);
    },
    async getReportList() {
      this.isReportLoading = true;
      try {
        let response = await smsService.getRentToDateReport(
          this.fromDate,
          this.toDate,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response.isSuccess && response.data.length > 0) {
          this.showTable = true;
          this.show1 = true;
          this.reportsList = response.data.map((item) => {
            item.menuAdjustedDate = false;
            item.adjustedCostLoading = false;
            return item;
          });
          this.isReportLoading = false;
        } else {
          this.reportsList = [];
          this.isReportLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = new Date().toISOString().slice(0, 10);
      this.reportsList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
      this.searchEquipName = "";
      this.searchPO = "";
      this.searchJob = "";
      this.searchContractId = "";
      this.getReportList();
    },

    // scheduled reports api calls

    clearTimeFrame() {
      this.scheduledtimeframe = "";
    },

    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    showScheduledForm() {
      this.scheduleedit = false;
      this.clearSchedule();
      this.displayScheduledForm = true;
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;

      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";

      this.searchFieldSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    closeSchedule() {
      this.scheduledialog = false;
      this.clearSchedule();
    },
    clearSchedule() {
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";

      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    openScheduledDialog() {
      this.$refs.modal.showScheduleModal();
    },

    OnFrequencyChange() {
      this.selectedDays = [];
    },
    // end scheduled reports methods
    async downloadReport(exportOption) {
      try {
        let response = await smsService.exportRentToDateExcel(
          exportOption,
          this.fromDate,
          this.toDate,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin."
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin."
        );
        this.isDownloading = false;
      }
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        }
        //case  "Pdf"
        else if (this.selectedExportOption == this.exportOptions[1]) {
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnew(
          machineValue
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = this.locations = response.data.filter(
            (e) => e.locationName != null
          );
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getJobSites() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null
          );
        } else {
          this.jobSiteList = [];
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
    },
    resetGroup() {
      this.selectedGroup = [];
    },
    resetMachine() {
      this.selectedMachine = [];
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
      this.jobSiteChange();
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearSearchEquipName() {
      this.searchEquipName = "";
    },
    clearSearch() {
      this.searchPO = "";
    },
    clearSearchJob() {
      this.searchJob = "";
    },
    clearSearchContractId() {
      this.searchContractId = "";
    },
    zoneChange() {
      this.selectedZonesNames = [];
      this.selectedZonesNames = this.selectedZone.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    modelChange() {
      this.selectedModelNames = [];
      this.selectedModelNames = this.selectedModel.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
    calcAdjustedCost(item) {
      item.menuAdjustedDate = false;
      item.adjustedCostLoading = true;

      let qty = item.qty;
      let dailyRate = item.dailyAmount;
      let weeklyRate = item.weeklyAmount;
      let monthlyRate = item.monthlyAmount;
      let dateOut = new Date(item.dateOut);
      let adjDateIn = new Date(item.adjustedDate);

      let daysOnRent = this.totalDaysOnRent(dateOut, adjDateIn);

      let unitCost = this.getItemTotal(
        daysOnRent,
        monthlyRate,
        weeklyRate,
        dailyRate
      );
      let adjAmt = unitCost * qty;

      // set the value
      item.adjustedProjectCost = adjAmt;
      item.adjustedCostLoading = false;
    },
    totalDaysOnRent(dateOut, dateIn) {
      // Set the unit values in milliseconds.
      const msecPerMinute = 1000 * 60;
      const msecPerHour = msecPerMinute * 60;
      const msecPerDay = msecPerHour * 24;

      // get the milliseconds
      let dateMsec = dateOut.valueOf();

      // Get the difference in milliseconds.
      let interval = dateIn.valueOf() - dateMsec;

      // Calculate how many days the interval contains. Subtract that
      // many days from the interval to determine the remainder.
      let days = Math.floor(interval / msecPerDay);

      return days;
    },
    getItemTotal(daysOnRent, monthlyRate, weeklyRate, dailyRate) {
      try {
        if (dailyRate === 0) {
          if (weeklyRate !== 0) {
            dailyRate = weeklyRate;
          } else {
            dailyRate = monthlyRate;
          }
        }
        if (weeklyRate === 0) {
          if (dailyRate !== 0) {
            weeklyRate = dailyRate * 7;
          } else {
            weeklyRate = monthlyRate;
          }
        }
        if (monthlyRate === 0) {
          if (dailyRate !== 0) {
            monthlyRate = weeklyRate * 4;
          } else {
            monthlyRate = dailyRate * 28;
          }
        }

        let monthsRemainder = daysOnRent % 28;
        let decimalMonths = daysOnRent / 28;
        let wholeMonths = parseInt(decimalMonths.toString(), 10);

        let weeksRemainder = monthsRemainder % 7;
        let decimalWeeks = monthsRemainder / 7;
        let wholeWeeks = parseInt(decimalWeeks.toString(), 10);

        let wholeDays = weeksRemainder;

        let total = wholeMonths * monthlyRate;
        total += wholeWeeks * weeklyRate;
        total += wholeDays * dailyRate;

        if (total < 0) {
          total = 0;
        }

        return total;
      } catch (error) {
        let msg = "Error calculating item total ";
        if (typeof error === "string" && error.length > 0) {
          msg += error;
        }
        this.$toast.error(msg);
      }
    },
  },
};
